import { createSlice } from "@reduxjs/toolkit";
import { setAnalyticsCachingData, setAppliedFilterHandler, setExporterCachingData, setFilterLoaderHandler, setFilterObjectHandler, setImporterCachingData, setShipmentsCachingData, setFilterMustNotHandler, setSelectedFilterListHandler, setLogisticsCachingData, setSearchParameters, setDateParameters, setPlanDetailsHandler } from "./shipment.action";

let importerCaching = {
  data: null,
  secondLevelData: null,
  sankeyData: null,
};

let exporterCaching = {
  data: null,
  secondLevelData: null,
  sankeyData: null,
};

let logisticsCaching = {
  data: null,
  secondLevelData: null,
  sankeyData: null,
};

const shipmentDetailsSlice = createSlice({
  name: "filtersData",
  initialState: {
    appliedFilter: {},
    filterObject: {},
    searchObject: {},
    filterLoader: true,
    filterMustNot: [],
    selectedFilterList: {},
    shipmentsCaching: [],
    importerCaching: { ...importerCaching },
    exporterCaching: { ...exporterCaching },
    logisticsCaching: { ...logisticsCaching },
    analyticsCaching: null,
    searchParameters: {
      searchCategory: "",
      searchedItem: "",
      matchType: "",
      dataSource: "",
    },
    dateParameters: {
      from: "",
      to: "",
    },
    planDetails: {},
  },
  reducers: {
    appliedFilterHandler: setAppliedFilterHandler,
    filterObjectHandler: setFilterObjectHandler,
    filterLoaderHandler: setFilterLoaderHandler,
    filterMustNotHandler: setFilterMustNotHandler,
    shipmentsCachingHandler: setShipmentsCachingData,
    importerCachingHandler: setImporterCachingData,
    exporterCachingHandler: setExporterCachingData,
    logisticsCachingHandler: setLogisticsCachingData,
    analyticsCachingData: setAnalyticsCachingData,
    selectedFilterListHandler: setSelectedFilterListHandler,
    resetCachingData: (state) => {
      state.importerCaching = importerCaching;
      state.exporterCaching = exporterCaching;
      state.logisticsCaching = logisticsCaching;
      state.analyticsCaching = null;
    },
    searchParametersHandler: setSearchParameters,
    dateParametersHandler: setDateParameters,
    planDetailsHandler: setPlanDetailsHandler,
  },
});

export const { appliedFilterHandler, filterObjectHandler, filterLoaderHandler, dateParametersHandler, shipmentsCachingHandler, importerCachingHandler, exporterCachingHandler, logisticsCachingHandler, analyticsCachingData, resetCachingData, filterMustNotHandler, selectedFilterListHandler, searchParametersHandler, planDetailsHandler } = shipmentDetailsSlice.actions;
export default shipmentDetailsSlice.reducer;
